import { PlatformDeviceInfo, type SystemInfoMemory } from "./platform-device-info";
import { PlatformType } from "./platform-type";
import { PlatformUserAgent } from "./platform-user-agent";

export class PlatformBrowser extends PlatformUserAgent {

    constructor() {
        super(PlatformType.Browser)
    }

    public static matchThisPlatform(): boolean {
        return true;
    }

    isSupported(): boolean {
        return false;
    }

    async getDeviceInfo(): Promise<PlatformDeviceInfo> {
        const baseInfo = await super.getInfo();
        return new PlatformDeviceInfo(
            baseInfo.macAddress,
            {
                model: "",
                manufacturer: "",
                buildVersion: "",
            },
            {
                macAddress: "",
                signalStrength: null,
                ssid: "",
                status: "",
            },
            {
                status: "",
                macAddress: "",
                cable: "",
            }
        );

    }
    public getOSVersion(): string | null {
        // TODO: Implement
        return null;
    }

    public async getMemoryInfo(): Promise<SystemInfoMemory | null> {
        // TODO: Implement
        return null;
    }

};